import React from 'react';
import { SocialPageButton } from '@minerva-analytics/pantheon';
import { FACEBOOK_LINK, INSTAGRAM_LINK } from '../../constants';

import SignUpForm from '../SignUpForm';

import {
  NavFooterContainer,
  SubscribeText,
  SocialContainer,
} from './NavFooter.styles';

const NavFooter = () => {
  return (
    <NavFooterContainer>
      <SubscribeText>
        Subscribe to get your free daily horoscope delivered to your inbox
      </SubscribeText>
      <SignUpForm
        formPlacement="nav-signup-form"
        stacked
      />
      <SocialContainer>
        <SocialPageButton type={`facebook`} href={FACEBOOK_LINK} />
        <SocialPageButton type={`instagram`} href={INSTAGRAM_LINK} />
      </SocialContainer>
    </NavFooterContainer>
  );
};

export default (NavFooter);
